import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { VendorRoutingModule } from './vendor-routing.module';
import { FetchUsersComponent } from './fetch-users/fetch-users.component';
import { ViewUserDetailsComponent } from './view-user-details/view-user-details.component';
import { SharedModule } from '../../shared/shared.module';
import { UtilitiesModule } from '../../shared/utilities/utilities.module';
import { MedicalProfessionSharedModule } from "../shared/medical-profession-shared.module";
import { UploadDocumentsVendorComponent } from './upload-documents-vendor/upload-documents-vendor.component';

@NgModule({
    declarations: [
        FetchUsersComponent,
        ViewUserDetailsComponent,
        UploadDocumentsVendorComponent
    ],
    imports: [
        PrimengModule,
        SharedModule,
        UtilitiesModule,
        CommonModule,
        VendorRoutingModule,
        MedicalProfessionSharedModule
    ]
})
export class VendorModule { }
